module.exports = __webpack_public_path__ + "fonts/iconfont.9f772d4b.woff2";